import { call, put } from 'redux-saga/effects';

import { loadFailure, loadEvent } from './actions';
import { ordersApi } from '../../../services/Api';

export function* getEventSaga(action: any) {
	try {
		const response = yield call(ordersApi.get, `/v1/public/event/url?url=${action.payload.url}&appType=WEB`);
		yield put(loadEvent(response.data));
	} catch (err) {
		yield put(loadFailure());
	}
}
